import { render, staticRenderFns } from "./VrstaSudionikaBase.vue?vue&type=template&id=4caee956&scoped=true&"
import script from "./VrstaSudionikaBase.vue?vue&type=script&lang=js&"
export * from "./VrstaSudionikaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caee956",
  null
  
)

export default component.exports